// define a mixin object

export const implantMixin = {
    props: {readonly: Boolean, height: String, width: String, selected: Boolean},
    data() {
        return {}
    },
    computed: {
        currentHeight() {
            return this.height ? this.height : '';
        },
        currentWidth() {
            return this.width ? this.width : '';
        }
    },
    watch: {},
    mounted() {
    },
    methods: {
        select(part) {
            if (this.readonly) return false;
            this.blocks[part] = !this.blocks[part]
        }
    }
};
